import { withConfig } from "@/utils/withConfig";
import { DonationAmount } from "./DonationAmount";
import type { DonationAmountProps } from "./DonationAmountProps";

export * from "./DonationAmount";
export * from "./DonationAmountProps";

export const DonationAmountWithConfig = withConfig<DonationAmountProps>(
  DonationAmount,
  "amount",
);
